import { OverlayPanel } from 'primereact/overlaypanel'
import brandLogo from 'assets/images/logo.svg'
import React, { MouseEvent, useEffect, useRef, useState } from 'react'
import { InputSwitch, InputSwitchChangeEvent } from 'primereact/inputswitch';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import * as myconst from "../constants"
import { useDispatch, useSelector } from 'react-redux';
import { handleActive, handleRON, handleSwitch, handleVoiceIds, resetQuestion } from 'redux/persistentSlice';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { changePassword, getLanguage, logout } from 'services/coversationService';
import { toast, ToastContent } from 'react-toastify';
import { Admin, Dashboard, generateInstance, helperDoc, helperDots, homeBot, homeDocumate, homeLens, homeQmate, homeVoice, languageIcon, lensAi, lensImage, lensSmartBack, searchMic, searchSend, searchMicActive, smartBackground, uploadFileIcon, uploadIcon, uploadImage, InForecast, SalesForecast, similarImage, imageExtender, imageExpansion, eyeIcon, CloseEyeIcon, generationIcon, generateEmailIcon, generatePostIcon, generateArticleIcon, generateProductIcon, generateIdeaIcon, imageCompare, techMateIcon, shopMateIcon, revMateIcon, DynamicPricingIcon, veedaIcon, insuranceIcon, edumateIcon, airaAiIcon } from 'assets/icons';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { RadioButton } from 'primereact/radiobutton';
import VoiceSearch from './VoiceSearch';
import { handleDocuMateCalled, handleDocuMateCounter, handleDocuMatePDF, handleDocuMateRadio, handleDocuMateRadioClick, handleDocumateLan, handleHideDocCompRadio, handleLoader, handleNotFound, handleQMateCounter, handleVoice, setAudioExtract, setAudioSentiment, setDocuMateValue, setEmailValue, setQmateValue, setStopId } from 'redux/counterSlice';
import { audio_extraction, voice_interaction_sentiment } from 'services/voiceInteractionService';
import { handleImageDetail, handleLensCounter, handleLensRecommendationImage, setCurrLens, setNewImage, setImageCompRadio } from 'redux/lensSlice';
import { deleteCoversation } from 'services/lensService';
import { Sidebar } from 'primereact/sidebar';
import { permission } from './../services/permissionService';



interface deleteCoversationType {
    client_env: string | null,
    user_name: string | null,
    conv_id: string | null,
    source_name: string | null,
}

const HeaderOne = ({ oh, overlayLens }: any) => {
    const [changeVisible, setChangeVisible] = useState<boolean>(false);
    const customHeader = (
        <div className="flex align-items-center gap-2">
            Change Password
        </div>
    );
    const [formValue, setFormValue] = useState({
        email: localStorage.getItem("username"),
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
    });
    const [showPassword, setShowPassword] = useState(false);
    const [showCnfPassword, setShowCnfPassword] = useState(false);
    const [showOldPassword, setShowOldPassword] = useState(false);
    const passRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/
    const [errors, setErrors] = useState<any>({});
    const currLens = useSelector((state: any) => state.lens.currLens);
    const imageCompRadio = useSelector((state: any) => state.lens.imageCompRadio);

    const navigate = useNavigate();
    const params = useParams();
    const [isKeyDown, setIsKeyDown] = useState(false);
    const op: any = useRef(null);
    // const oh: any = useRef(null);
    const fileInputRef: any = useRef(null);
    const inputRefDocuMate: any = useRef(null);
    const voiceInputRef: any = useRef(null);
    const lensInputRef: any = useRef(null);
    const logos = JSON.parse(localStorage.getItem('logos') as any);
    const logo = logos !== null || logos !== "" ? `data:image/png;base64,${logos?.logo_side_img}` : brandLogo;
    const [visible, setVisible] = useState(false);
    const [qmate, setQmate] = useState<string>('');
    const [emailGen, setEmailGen] = useState<string>('');
    const docuMatePDF = useSelector((state: any) => state.counter.docuMatePDF);
    const docuMateText = useSelector((state: any) => state.counter.docuMateText);
    const currentActive = useSelector((state: any) => state.persistent.currentActive);
    const RON = useSelector((state: any) => state.persistent.RON);
    const hideDocCompare = useSelector((state: any) => state.counter.hideDocCompare);
    const isAnswerCalling = useSelector((state: any) => state.counter.isAnswerCalling);
    const deleted = useSelector((state: any) => state.counter.deleted);
    const hideDocSyn = useSelector((state: any) => state.counter.hideDocSyn);
    const handleChangePassword = (e: any) => {
        op.current.toggle(e)
        navigate("/change-password")
        const synth = window.speechSynthesis;
        if (synth.speaking) {
            synth.cancel();
            dispatch(setStopId(''));
        }
    }
    let featureHistory: any = JSON.parse(localStorage.getItem("feature-flag") || '{}');
    const dispatch = useDispatch();
    const ShowChangePassword = featureHistory[myconst.FEATURE_FLAG_KEY.changepassword]
    const VoiceSearchFlag = featureHistory[myconst?.FEATURE_FLAG_KEY?.voiceSearch]
    const showNotification = featureHistory[myconst.FEATURE_FLAG_KEY.showNotification]
    const inputbox: any = document.querySelector('.input-box');
    const sendButton: any = document.querySelector('#send-button');
    const userName = localStorage.getItem("username")
    const first_name = localStorage.getItem("firstName");
    const last_name = localStorage.getItem("lastName");
    const Capitalize = (str: string) => {
        return str?.charAt(0)?.toUpperCase() + str?.slice(1);
    }
    const fName = Capitalize(first_name as any)
    const lName = Capitalize(last_name as any)
    const is_switch_active = useSelector((state: any) => state.persistent.is_switch_active);
    const docuMateRadio = useSelector((state: any) => state.counter.docuMateRadio);

    const firstLetter = first_name?.charAt(0)?.toUpperCase();
    // const firstLetter = fName?.charAt(0) + lName?.charAt(0);
    let featureFlag: any = JSON.parse(localStorage.getItem("feature-flag") || '{}');
    const announcementText = JSON.parse(localStorage.getItem("announcements") as any);
    const scrollingText = announcementText?.map((i: any) => i.notification_text)
    const update_time: any = useRef(null);
    const qmateValue = useSelector((state: any) => state.counter.qmateValue);
    const emailValue = useSelector((state: any) => state.counter.emailValue);
    const qMateCounter = useSelector((state: any) => state.counter.qMateCounter);
    const emailCounter = useSelector((state: any) => state.counter.emailCounter);
    const voiceSearch = VoiceSearch(
        setIsKeyDown,
        inputbox,
        sendButton,
        setQmate,
    );

    //**Qmate**
    const handleStartListening = voiceSearch.handleStartListening;

    const handleVoiceIconClicked = () => {
        const synth = window.speechSynthesis;
        if (synth.speaking) {
            synth.cancel();
        }
        dispatch(setStopId(''));
        setIsKeyDown(true);
        setQmate('Listening...');
        // dispatch(setQmateValue('Listening...'));
        if (inputbox) {
            inputbox.setAttribute('disabled', true);
        }
        if (sendButton) {
            sendButton.setAttribute('disabled', true);
        }

        handleStartListening();
        // update_time.current.focus();
    };
    //Handle Search input box
    const handleInputChange = (e: any) => {
        setQmate(e.target.value)
    };
    const handleInputChangeEmail = (e: any) => {
        setEmailGen(e.target.value)
    };

    const handleSwitchChange = (e: InputSwitchChangeEvent) => {
        dispatch(handleSwitch(e.value));
        const synth = window.speechSynthesis;
        if (synth.speaking) {
            synth.cancel();
            dispatch(setStopId(''));
        }
    }

    const deleteConversationByC_id = async (body: deleteCoversationType) => {
        try {
            const { result, error } = await deleteCoversation(body);
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
        } catch (error: any) {
            // dispatch(handleLoader(false));
            toast.error(error, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }

    const handleSignout = async () => {
        const refreshToken = localStorage.getItem("refresh_token");
        const synth = window.speechSynthesis;
        if (synth.speaking) {
            synth.cancel();
            dispatch(setStopId(''));
        }
        try {
            const { result, error } = await logout(refreshToken)
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            if (localStorage.getItem("conversation_id") !== null) {
                const body = {
                    client_env: localStorage.getItem("clientName"),
                    user_name: localStorage.getItem("username"),
                    conv_id: localStorage.getItem("conversation_id"),
                    source_name: localStorage.getItem("source_name")
                }
                await deleteConversationByC_id(body)
            }
            // toast.success(result.message, {
            //     style: {
            //         backgroundColor: '#F1F1F1', // Grey background
            //     }
            // });
            console.log("localStorage.getItem('clientName')", localStorage.getItem('clientName'))
            // if (localStorage.getItem("clientName") === 'Veedalifescience') {
            //     navigate(`/login?env=Veedalifescience`)
            // } else 
            if (localStorage.getItem('clientName') === 'Amspec_clone') {
                console.log("called in condition")
                navigate("/login?env=AmSpec")
            } else {
                navigate("/login")
            }
            dispatch(handleActive(""));
            // localStorage.clear();
            localStorage.removeItem('access_token');
            localStorage.removeItem('announcements');
            // //localStorage.removeItem('clientName');
            localStorage.removeItem('default_label');
            localStorage.removeItem('default_questions');
            localStorage.removeItem('feature-flag');
            localStorage.removeItem('firstName');
            localStorage.removeItem('isLogged');
            localStorage.removeItem('lastActivity');
            localStorage.removeItem('lastName');
            localStorage.removeItem('loginTime');
            localStorage.removeItem('logos');
            localStorage.removeItem('permissions');
            localStorage.removeItem('refresh_token');
            localStorage.removeItem('username');
            localStorage.removeItem('lastBotQuestion');
            localStorage.removeItem('botId');
            localStorage.removeItem("wrongAttempt");
            localStorage.removeItem("attempt");
            localStorage.removeItem('handler_name_exist');
            localStorage.removeItem("false_attempt");
            localStorage.removeItem("user_name_attempts")
            localStorage.removeItem("chatUserName");
            localStorage.removeItem("chat_access_token");
            dispatch(resetQuestion())
        } catch (error: any) {
            toast.error(error, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }

    const reject = () => {
        setVisible(false)
    }
    const location = useLocation()
    const temp = location.pathname.split('/').filter(entry => entry.trim() !== '');
    const isHomeRoute = location.pathname.includes('/home');

    const lensCompName = () => {
        switch (temp[1]) {
            case 'similar-image':
                return 'Similar Image';
            case 'smart-background':
                return 'Smart Background';
            case 'generate-instance':
                return 'Generate Instance';
            case 'image-extender':
                return 'Image Extender';
            case 'image-comparison':
                return 'Image Comparison';
        }
    }

    const componentName = () => {
        switch (temp[0]) {
            case 'chat-bot':
                return "QMate!";
            case 'document-processing':
                return "DocuMate!";
            case 'voice':
                return "Voice!";
            case 'lens':
                return lensCompName();
            case 'admin':
                return "Admin";
            case 'user-dashboard':
                if (localStorage.getItem("clientName") !== 'Veedalifescience') {
                    return "User Dashboard";
                } else {
                    return ''
                }
            case 'forecast':
                return "Inventory Forecast";
            case 'generate-email':
                return "Generate Email";
            case 'generate-post':
                return "Generate Post";
            case 'generate-article':
                return "Generate Article";
            case 'generate-product':
                return "Generate Product Description";
            case 'generate-idea':
                return "Generate Idea";
            case 'salesforecast':
                return "Sales Forecast"
            case 'dynamic-pricing':
                return "Dynamic Pricing"
            case 'creator-mate':
                return "CreatorMate"
            default:
                return "";
        }
    }
    const solutionsArray = ["generate-article", "generate-email", "generate-post", "generate-idea", "generate-product", "sentiment-analysis"]
    const lensImages = () => {
        switch (temp[1]) {
            case 'similar-image':
                return similarImage;
            case 'smart-background':
                return smartBackground;
            case 'generate-instance':
                return generateInstance;
            case 'image-extender':
                return imageExtender;
            case 'image-comparison':
                return imageCompare;
        }
    }


    const imageSrc = () => {
        switch (temp[0]) {
            case 'chat-bot':
                return homeQmate;
            case 'document-processing':
                return homeDocumate;
            case 'voice':
                return homeVoice;
            case 'lens':
                return lensImages();
            case 'admin':
                return Admin;
            case 'user-dashboard':
                if (localStorage.getItem("clientName") !== 'Veedalifescience') {
                    return Dashboard;
                } else {
                    return ''
                }
            case 'forecast':
                return InForecast;
            case 'salesforecast':
                return SalesForecast;
            case 'dynamic-pricing':
                return DynamicPricingIcon;
            case 'generate-email':
                return generateEmailIcon;
            case 'generate-post':
                return generatePostIcon;
            case 'generate-article':
                return generateArticleIcon;
            case 'generate-product':
                return generateProductIcon;
            case 'generate-idea':
                return generateIdeaIcon;
            case 'creator-mate':
                return techMateIcon;
            default:
                return "";
        }
    }

    const handleSendQueryButton = () => {
        dispatch(setQmateValue(qmate.trim()));
        const synth = window.speechSynthesis;
        if (synth.speaking) {
            synth.cancel();
        }
        dispatch(setStopId(""));
        // navigate(`/chat-bot/${temp[1]}`)
    }
    const handleSendQueryButtonEmail = () => {
        dispatch(setEmailValue(emailGen.trim()));
        const synth = window.speechSynthesis;
        if (synth.speaking) {
            synth.cancel();
        }
        dispatch(setStopId(""));
        // navigate(`/generate-email/${temp[1]}`)
    }

    const handleEnterPressed = (e: any) => {
        if (e.key === 'Enter') handleSendQueryButton();
    };
    const handleEnterPressedEmail = (e: any) => {
        if (e.key === 'Enter') handleSendQueryButtonEmail();
    };

    const handleBrowseFiles = async (e: any) => {
        const file = e?.target?.files[0];
        if (file) {
            if (file?.type === "application/pdf") {
                const maxSize = 10 * 1024 * 1024; // 10 MB in bytes
                if (file?.size > maxSize) {
                    toast.error('File size should not be more than 10 MB', {
                        style: {
                            backgroundColor: '#F1F1F1', // Grey background
                        }
                    });
                    fileInputRef.current.value = null
                    return;
                }
                dispatch(handleLoader(true));
                const base64Code: any = await myconst.fileToBase64(file)
                const correctBase64 = await myconst.manipulateBase64Data(base64Code)
                const body = {
                    query: "",
                    user_name: localStorage.getItem('username') ?? 'meet.patel@rysun.com',
                    file_data: correctBase64,
                    file_name: file.name
                }
                dispatch(handleDocuMateCounter(true))
                try {
                    const { result, error } = await getLanguage(body)
                    if (error) {
                        throw error;
                    }
                    if (result?.error) {
                        throw result.error;
                    }
                    // setFileLanguage(result.PDF_Language)
                    dispatch(handleDocumateLan(result.PDF_Language));
                    const temp: any = {}
                    temp.pdf = correctBase64;
                    temp.name = file.name
                    dispatch(handleDocuMatePDF(temp));
                    dispatch(handleLoader(false));
                    navigate("/document-processing/new-chat")
                    dispatch(handleDocuMateRadio('Q&A'))
                } catch (error: any) {
                    toast.error(error, {
                        style: {
                            backgroundColor: '#F1F1F1', // Grey background
                        }
                    });
                    dispatch(handleLoader(false));
                }
                // setInputFile(e.target.files[0])
                fileInputRef.current.value = null
            } else {
                toast.error("File is not supported", {
                    style: {
                        backgroundColor: '#F1F1F1', // Grey background
                    }
                });
                fileInputRef.current.value = null
            }
        }
    }

    //Handle Search input box
    const handleInputChangeDocuMate = (e: any) => {
        dispatch(setDocuMateValue(e.target.value));
    };


    const handleSendQueryButtonDocuMate = () => {
        const trimmedQmate = docuMateText.trim();
        if (trimmedQmate !== "") {
            dispatch(handleDocuMateCalled(true));
            // navigate(`/document-processing/${temp[1]}`)
            inputRefDocuMate?.current?.blur()
        }
    }

    const handleEnterPressedDocuMate = (e: any) => {
        const trimmedQmate = docuMateText.trim();
        if (e.key === 'Enter') {
            if (trimmedQmate === "") {
                e.preventDefault();
            } else {
                handleSendQueryButtonDocuMate();
            }
        }
    };

    const handleMenu = (data: string, value: string,) => {
        dispatch(handleActive(data));
        if (data === "admin") {
            if (location.pathname === '/home') {
                const state = {
                    current_active: currentActive,
                    ron: RON,
                    curr_lens: currLens,
                };
                navigate(`/home`, { replace: true, state })
            }
            if (adminArrayFilter.length > 0) {
                switch (adminArrayFilter[0].key) {
                    case "aggregative_dashboard":
                        navigate("/admin/dashboard")
                        break;
                    case "announcements":
                        navigate("/admin/announcements")
                        break;
                    case "group_management":
                        navigate("/admin/groups")
                        break;
                    case "user_management":
                        navigate("/admin/users")
                        break;
                    case "role_management":
                        navigate("/admin/roles")
                        break;
                    case "permission_management":
                        navigate("/admin/permission")
                        break;
                    case "doc_approval":
                        navigate("/admin/doc-approval")
                        break;
                    case "flag_settings":
                        navigate("/admin/flag-settings")
                        break;
                    case "configuration":
                        navigate("/admin/configuration")
                        break;
                    case "black_listed_word":
                        navigate("/admin/black-listed-words")
                        break;
                    case "scrapper":
                        navigate("/admin/web-scrapper")
                        break;
                    case "sftp":
                        navigate("/admin/pdf-upload")
                        break;
                    case "bot_configuration":
                        navigate("/admin/bot-configuration")
                        break;
                    case "conversation_history":
                        navigate("/admin/conversation-history")
                        break;
                }
            }

        } else {
            navigate("/home")
        }
        dispatch(setCurrLens(value));
        dispatch(handleActive(data));
        const synth = window.speechSynthesis;
        if (synth.speaking) {
            synth.cancel();
        }
        dispatch(setStopId(''));
        dispatch(handleRON('product'));
        oh.current.hide();
    }

    const handleCompareImage = async (value: string) => {
        await dispatch(setCurrLens(value));
        navigate("/lens/image-comparison");
    };

    const handleSolution = () => {
        if (marketObjectFilter.length > 0) {
            switch (marketObjectFilter[0].key) {
                case "email_generation":
                    dispatch(handleActive("generateEmail"));
                    break;
                case "post_generation":
                    dispatch(handleActive("generatePost"));
                    break;
                case "article_generation":
                    dispatch(handleActive("generateArticle"));
                    break;
                case "idea_generation":
                    dispatch(handleActive("generateIdea"));
                    break;
                case "product_des_generation":
                    dispatch(handleActive("generateProduct"));
                    break;
                case "generate_sentiment_analysis":
                    dispatch(handleActive("sentimentAnalysis"));
                    break;
            }
        }
        navigate("/home")
        const synth = window.speechSynthesis;
        if (synth.speaking) {
            synth.cancel();
        }
        dispatch(setStopId(''));
        dispatch(handleRON('solution'));
        oh.current.hide();
    }

    const handleShopMate = () => {
        dispatch(handleActive("shopmate"));
        navigate("/home")
        const synth = window.speechSynthesis;
        if (synth.speaking) {
            synth.cancel();
        }
        dispatch(setStopId(''));
        dispatch(handleRON('shopmate'));
        oh.current.hide();
    }

    const handleButterPie = () => {
        if (location.pathname === '/home') {
            const state = {
                current_active: currentActive,
                ron: RON,
                curr_lens: currLens,
            };
            navigate(`/home`, { replace: true, state })
        }
        navigate('/creator-mate')
        const synth = window.speechSynthesis;
        if (synth.speaking) {
            synth.cancel();
        }
        dispatch(setStopId(''));
        dispatch(handleActive("creatorMate"));
        dispatch(handleRON('product'));
        oh.current.hide();
    }

    const handleNewChatClick = (data: string) => {
        navigate("/home");
        if (solutionsArray.includes(temp[0])) {
            switch (temp[0]) {
                case 'generate-email':
                    dispatch(handleActive("generateEmail"));
                    break;
                case 'generate-post':
                    dispatch(handleActive("generatePost"));
                    break;
                case 'generate-article':
                    dispatch(handleActive("generateArticle"));
                    break;
                case 'generate-product':
                    dispatch(handleActive("generateProduct"));
                    break;
                case 'generate-idea':
                    dispatch(handleActive("generateIdea"));
                    break;
                case 'sentiment-analysis':
                    dispatch(handleActive("sentimentAnalysis"))
                    break;
                default:
                    return "";
            }
            dispatch(handleRON('solution'));
        } else {
            dispatch(handleActive(data));
            dispatch(handleRON('product'));
        }
        const synth = window.speechSynthesis;
        if (synth.speaking) {
            synth.cancel();
        }
    }

    useEffect(() => {
        if (docuMateRadio === 'Q&A') {
            inputRefDocuMate?.current?.focus();
        }
    }, [docuMateRadio])

    useEffect(() => {
        if (qmate !== "") {
            update_time?.current?.focus();
        }
    }, [qmate])

    // **Voice**
    const handleVoiceToggle = () => {
        // Trigger the file input when the button is clicked
        voiceInputRef.current.click();
    };
    const postSentiment = async (body: any, id: string) => {
        dispatch(handleLoader(true));
        try {
            const { result, error } = await voice_interaction_sentiment(body);
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            dispatch(setAudioSentiment(result));
            dispatch(handleVoice(true));
            navigate(`/voice/${id}`)
            dispatch(handleLoader(false));
            dispatch(handleVoiceIds([]));
        } catch (error: any) {
            dispatch(handleLoader(false));
            toast.error(error, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            });
        }
    }
    const handleVoiceChange = async (event: any) => {
        const file = event.target.files[0];
        const size = Number(event?.target?.files[0]?.size / 1048576);
        if (file) {
            if (size < 5 && file.size > 0) {
                if (file && myconst.audioTypes.includes(file.type)) {
                    dispatch(handleLoader(true));
                    const base64Code: any = await myconst.fileToBase64(file)
                    const correctBase64 = await myconst.manipulateBase64Data(base64Code);
                    const body: any = {};
                    body.user_name = localStorage.getItem("username");
                    body.file_data = correctBase64;
                    body.file_name = myconst.fileExtChange(file);
                    body.audio_file_name = file.name;
                    try {
                        const { result, error } = await audio_extraction(body);
                        if (error) {
                            throw error
                        }
                        if (result?.error) {
                            throw result.error
                        }
                        dispatch(setAudioExtract(result));
                        const data: any = {}
                        data.user_name = localStorage.getItem("username");
                        data.audio_id = result.audio_id;
                        data.file_name = result.file_name;
                        data.file_data = result.encoded_text_value;
                        data.audio_file_name = file.name;
                        await postSentiment(data, result.audio_id);
                        voiceInputRef.current.value = null;
                    } catch (error: any) {
                        dispatch(handleLoader(false));
                        toast.error(error, {
                            style: {
                                backgroundColor: '#F1F1F1', // Grey background
                            }
                        });
                    }
                } else {
                    voiceInputRef.current.value = null;
                    toast.error("File is not supported", {
                        style: {
                            backgroundColor: '#F1F1F1', // Grey background
                        }
                    })
                }
            } else {
                voiceInputRef.current.value = null;
                toast.error("File size should not be more than 5 MB", {
                    style: {
                        backgroundColor: '#F1F1F1', // Grey background
                    }
                })
            }
        }
    }

    //  **lens**
    const handleLensToggle = () => {
        // Trigger the file input when the button is clicked
        lensInputRef.current.click();
    };
    const handleLensChange = async (event: any) => {
        const file = event.target.files[0];
        const size = Number(event?.target?.files[0]?.size / 1048576);
        const imageDetailObject: { name: string, type: string } = {
            name: '',
            type: ''
        }
        imageDetailObject.name = file?.name
        imageDetailObject.type = file?.type
        if (file) {
            if (size < 10 && file.size > 0) {
                if (file && myconst.imageTypes.includes(file.type)) {
                    const base64Code: any = await myconst.fileToBase64(file)
                    const correctBase64 = await myconst.manipulateBase64Data(base64Code);
                    dispatch(handleLensRecommendationImage(correctBase64))
                    dispatch(handleImageDetail(imageDetailObject))
                    dispatch(handleLensCounter())
                    lensInputRef.current.value = "";
                    event.target.value = null;
                } else {
                    toast.error("File is not supported", {
                        style: {
                            backgroundColor: '#F1F1F1', // Grey background
                        }
                    });
                    if (lensInputRef.current.value !== "") {
                        lensInputRef.current.value = "";
                    }
                }
            } else {
                toast.error("File size should not be more than 10 MB", {
                    style: {
                        backgroundColor: '#F1F1F1', // Grey background
                    }
                });
                if (lensInputRef.current.value !== "") {
                    lensInputRef.current.value = "";
                }
            }
        }
    }


    const handleValidation = (formValue: { [s: string]: any }) => {
        const errors: { [s: string]: any } = {};
        if (!formValue.oldPassword) {
            errors.oldPassword = 'Old password is required';
        }
        if (!formValue.newPassword) {
            errors.newPassword = 'New password is required';
        }
        if (!formValue.confirmPassword) {
            errors.confirmPassword = 'Confirm Password is required';
        }
        if (formValue.newPassword && formValue.newPassword === formValue.oldPassword) {
            errors.newPassword = 'The new password must be different from the old password';
        }
        if (formValue.newPassword && !passRegex.test(formValue.newPassword)) {
            errors.newPassword = 'Password must be of minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character';
        }
        if (formValue.confirmPassword !== formValue.newPassword) {
            errors.confirmPassword = 'Confirm Password does not match with the new password';
        }
        return errors;
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFormValue({ ...formValue, [e.target.name]: e.target.value });
    };

    const handleUpdatePassword = async (e: MouseEvent<HTMLSpanElement, globalThis.MouseEvent>) => {
        e.preventDefault();
        // Perform validation
        const validationErrors = handleValidation(formValue);

        if (Object.keys(validationErrors).length === 0) {
            dispatch(handleLoader(true));
            try {
                const { result, error } = await changePassword(formValue);
                if (error) {
                    throw error
                }
                if (result?.error) {
                    throw result.error
                }
                dispatch(handleLoader(false));
                toast.success(result.message, {
                    style: {
                        backgroundColor: '#F1F1F1', // Grey background
                    }
                })
                setChangeVisible(false)
                setShowPassword(false)
                setShowOldPassword(false)
                setShowCnfPassword(false)
                setErrors({})
                setFormValue({
                    email: localStorage.getItem("username"),
                    oldPassword: "",
                    newPassword: "",
                    confirmPassword: "",
                })
            } catch (error) {
                toast.error(error as ToastContent<unknown>, {
                    style: {
                        backgroundColor: '#F1F1F1', // Grey background
                    }
                })
                dispatch(handleLoader(false));
            }
        } else {
            dispatch(handleLoader(false));
            // Form is invalid; display validation errors
            setErrors(validationErrors);
        }
    }

    const handleCloseChangePassword = () => {
        setChangeVisible(false)
        setShowPassword(false)
        setShowOldPassword(false)
        setShowCnfPassword(false)
        setErrors({})
        setFormValue({
            email: localStorage.getItem("username"),
            oldPassword: "",
            newPassword: "",
            confirmPassword: "",
        })
    }

    const handleRadioChange = (e: any) => {
        dispatch(setImageCompRadio(e.value));
    };

    const goHome = () => {
        if (q_aManagementObject?.permissions) {
            dispatch(handleActive("qmate"));
            dispatch(handleRON('product'));
        } else if (uploadDocManagementObject?.permissions) {
            dispatch(handleRON('product'));
            dispatch(handleActive("documate"));
        } else if (voiceManagementObject?.permissions) {
            dispatch(handleRON('product'));
            dispatch(handleActive("voice"));
        } else if (botManagementObject?.permissions) {
            dispatch(handleActive("shopmate"));
            dispatch(handleRON('shopmate'));
        } else if (lensObject) {
            dispatch(handleRON('product'));
            dispatch(handleActive("lens"));
        }
        navigate("/home")
        setTimeout(() => {
            window.location.reload();
        }, 500)
        dispatch(setCurrLens(""))
        oh.current.hide();
        const synth = window.speechSynthesis;
        if (synth.speaking) {
            synth.cancel();
        }
        dispatch(setStopId(''));
    }

    // const handleDocRadioChange = (newRadioValue: string) => {
    //     const previousRadioValue = docuMateRadio;  
    //     if (newRadioValue === 'Compare' || newRadioValue === 'Synthesization') {
    //         dispatch(handleDocuMateRadioClick(docuMateRadio)); 
    //     }
    //     dispatch(handleDocuMateRadio(newRadioValue)); 
    // };

    const handleDocRadioChange = (newRadioValue: string) => {
        if (newRadioValue !== docuMateRadio) {
            dispatch(handleDocuMateRadio(newRadioValue));
            dispatch(handleDocuMateRadioClick(""));
        }
    };

    const handleDocRadioClick = (newRadioValue: string) => {
        const previousRadioValue = docuMateRadio;
        if (newRadioValue !== previousRadioValue) {
            if (newRadioValue === 'Compare' || newRadioValue === 'Synthesization') {
                dispatch(handleDocuMateRadioClick(previousRadioValue));
            }
            dispatch(handleDocuMateRadio(newRadioValue));
        }
    };

    const permissionLocal: any = localStorage.getItem("permissions")
    const permission: any = JSON.parse(permissionLocal);
    const roleManagementObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.role);
    const groupManagementObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.group);
    const announcementsManagementObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.announcements);
    const userManagementObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.user);
    const dashboardManagementObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.dashboard);
    const uploadDocManagementObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.uploadDoc);
    const permissionManagementObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.permissions);
    const flagSettingsManagementObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.flagSettings);
    const q_aManagementObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.q_a);
    const voiceManagementObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.voice);
    const botManagementObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.bot);
    const docApprovalObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.docApproval);
    const blackListedObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.black_listed_word);
    const scrapperObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.scrapper);
    const configurationObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.configuration);
    const botConfigurationObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.bot_configuration);
    const conversationHistory = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.conversationHistory);
    const sftpObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.sftp);
    const adminArray = [roleManagementObject?.permissions?.view, groupManagementObject?.permissions?.view, announcementsManagementObject?.permissions?.view, userManagementObject?.permissions?.view, dashboardManagementObject?.permissions, permissionManagementObject?.permissions, flagSettingsManagementObject?.permissions, docApprovalObject?.permissions, blackListedObject?.permissions, configurationObject?.permissions, botConfigurationObject?.permissions, scrapperObject?.permissions, sftpObject?.permissions, conversationHistory?.permissions]
    const adminShow = adminArray?.some((a) => a === true)
    const adminArrayFilter = [dashboardManagementObject, announcementsManagementObject, groupManagementObject, userManagementObject, roleManagementObject, permissionManagementObject, docApprovalObject, flagSettingsManagementObject, configurationObject, blackListedObject, scrapperObject, sftpObject, botConfigurationObject, conversationHistory].filter((a) => {
        if (typeof (a?.permissions) === "object") {
            return a?.permissions?.view === true
        } else {
            return a?.permissions === true
        }
    })
    const imageExtenderObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.imageExtender);
    const similarImagesObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.similarImages);
    const smartBackgroundObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.smartBackground);
    const generateInstanceObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.generateInstance);
    const inventoryForecastObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.inventoryForecast);
    const salesForecastObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.salesForecast);
    const dynamicPricingObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.dynamicPricing);
    const imageComparisionObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.imageComparison);
    const productDesGenerationObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.productDesGeneration);
    const sentimentAnalysisObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.sentimentAnalysis);
    const postGenerationObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.postGeneration);
    const ideaGenerationObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.ideaGeneration);
    const emailGenerationObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.emailGeneration);
    const articleGenerationObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.articleGeneration);
    const lensObject = [imageExtenderObject?.permissions, similarImagesObject?.permissions, smartBackgroundObject?.permissions, generateInstanceObject?.permissions, imageComparisionObject?.permissions].some((a) => a === true);
    const marketObject = [productDesGenerationObject?.permissions, postGenerationObject?.permissions, ideaGenerationObject?.permissions, emailGenerationObject?.permissions, articleGenerationObject?.permissions, sentimentAnalysisObject?.permissions].some((a) => a === true);
    const marketObjectFilter = [emailGenerationObject, postGenerationObject, articleGenerationObject, ideaGenerationObject, productDesGenerationObject, sentimentAnalysisObject].filter((a) => a?.permissions === true);

    useEffect(() => {
        setQmate("");
        dispatch(setQmateValue(''))
    }, [qmateValue, qMateCounter, navigate])
    useEffect(() => {
        setEmailGen("");
    }, [emailValue, emailCounter])

    return (
        <div onClick={() => oh.current.hide()} className={`home-header ${temp[0] === 'home' ? "home-page-header" : ""} ${temp[0] === 'chat-bot' ? "qmate-header" : ""} ${temp[0] === 'document-processing' ? "document-header" : ""} ${temp[0] === 'voice' ? "voice-header" : ""} ${temp[0] === 'lens' ? "lens-header" : ""} ${temp[0] === 'admin' ? "admin-header" : ""}`}>
            {/* <div className={`home-header`} style={{ alignItems: docuMateRadio === 'Q&A' ? "flex-start" : "" }}> */}
            <a style={{ cursor: "pointer" }} className='brand-logo' onClick={goHome}>
                <img className='brand-logo' src={logo} alt='brand-icon' />
            </a >
            {(showNotification === true || showNotification === undefined) && isHomeRoute && (<div className='disclaimerText'>
                <p className='scrolling-text'>{scrollingText?.map((a: string, index: number) => (<span className='ms-3' key={index}>{scrollingText.lenght > 1 && `##`} {a}</span>))}</p>
            </div>)}
            {temp[0] === 'chat-bot' &&
                <div className='user-input-area'>
                    <div className='home-search'>
                        <input type={"text"} onChange={handleInputChange}
                            onKeyDown={(e) => {
                                if (e.key === "Enter" && qmate !== "Listening..." && !isAnswerCalling) {
                                    handleEnterPressed(e)
                                }
                            }}
                            style={{ pointerEvents: deleted ? 'none' : 'visible' }}
                            ref={update_time}
                            readOnly={qmate === "Listening..."}
                            value={qmate}
                            placeholder="Ask me anything"
                            className='radius-input input-box'
                        />
                        {/* <InputText ref={update_time} style={{ cursor: "auto" }} onKeyDown={(e) => handleEnterPressed(e)} onChange={handleInputChange} value={qmate} className='radius-input input-box' placeholder='Ask me anything' /> */}
                        <i className='sec-last-icon' style={{ opacity: (qmate === "" || qmate === "Listening..." || qmate.trim() === "" || isAnswerCalling || deleted) ? "0.5" : "", pointerEvents: (qmate === "" || qmate === "Listening..." || qmate.trim() === "" || isAnswerCalling || deleted) ? "none" : "visible" }} onClick={handleSendQueryButton} id='send-button'><img src={searchSend} alt='send-btn' /></i>
                        {(VoiceSearchFlag === true || VoiceSearchFlag === undefined) && (
                            <i className='last-icon' style={{ opacity: deleted ? '0.5' : '', pointerEvents: deleted ? 'none' : 'visible' }}><img src={qmate === "Listening..." ? searchMicActive : searchMic} onClick={handleVoiceIconClicked} title='Search via Voice' alt='mic-btn' /></i>
                        )}
                    </div>
                    {/* <Button label="New Topic" outlined icon="pi pi-plus" className='btn-voice-list outline-icon-btn' onClick={() => { navigate("/chat-bot/new-chat"); dispatch(handleQMateCounter(true)) }} /> */}
                    <Button label="New Topic" outlined icon="pi pi-plus" className='btn-voice-list outline-icon-btn' onClick={() => { handleNewChatClick("qmate"); setQmate("") }} />
                </div>
            }
            {temp[0] === 'document-processing' &&
                <div className='user-input-area user-input-doc'>
                    <div className={`flex  ${Object.keys(docuMatePDF).length === 0 ? "justify-content-end" : "justify-content-between"} align-items-center w-100 doc-radio-wrap`}>
                        {Object.keys(docuMatePDF).length > 0 &&
                            <div className="flex flex-wrap gap-3">
                                <div className={`flex align-items-center doc-radio ${docuMateRadio === 'Q&A' ? 'radio-active' : ""}`} onClick={() => handleDocRadioChange('Q&A')}>
                                    <RadioButton inputId="ingredient1" name="input-radio-grp" value="Q&A" checked={docuMateRadio === 'Q&A'} />
                                    <label htmlFor="ingredient1" className="ml-2">Q&A</label>
                                </div>
                                <div className={`flex align-items-center doc-radio ${docuMateRadio === 'Entities' ? 'radio-active' : ""}`} onClick={() => handleDocRadioChange('Entities')}>
                                    <RadioButton inputId="ingredient2" name="input-radio-grp" value="Entities" checked={docuMateRadio === 'Entities'} />
                                    <label htmlFor="ingredient2" className="ml-2">Entities</label>
                                </div>
                                <div className={`flex align-items-center doc-radio ${docuMateRadio === 'Summarization' ? 'radio-active' : ""}`} onClick={() => handleDocRadioChange('Summarization')}>
                                    <RadioButton inputId="ingredient3" name="input-radio-grp" value="Summarization" checked={docuMateRadio === 'Summarization'} />
                                    <label htmlFor="ingredient3" className="ml-2">Summarization</label>
                                </div>
                                <div className={`flex align-items-center doc-radio ${docuMateRadio === 'Classification' ? 'radio-active' : ""}`} onClick={() => handleDocRadioChange('Classification')}>
                                    <RadioButton inputId="ingredient4" name="input-radio-grp" value="Classification" checked={docuMateRadio === 'Classification'} />
                                    <label htmlFor="ingredient4" className="ml-2">Classification</label>
                                </div>
                                <div className={`flex align-items-center doc-radio ${docuMateRadio === 'Compare' ? 'radio-active' : hideDocCompare ? 'disable-radio-button' : ""}`}
                                    onClick={() => !hideDocCompare && handleDocRadioClick('Compare')}>
                                    <RadioButton inputId="ingredient5" disabled={hideDocCompare ? true : false} name="input-radio-grp" value="Compare" checked={docuMateRadio === 'Compare'} onChange={() => handleDocRadioChange('Compare')} />
                                    <label htmlFor="ingredient5" className="ml-2">Compare</label>
                                </div>
                                <div className={`flex align-items-center doc-radio ${docuMateRadio === 'Synthesization' ? 'radio-active' : hideDocSyn ? 'disable-radio-button' : ""}`}
                                    onClick={() => !hideDocSyn && handleDocRadioClick('Synthesization')}>
                                    <RadioButton inputId="ingredient6" disabled={hideDocSyn ? true : false} name="input-radio-grp" value="Synthesization" checked={docuMateRadio === 'Synthesization'} onChange={() => handleDocRadioChange('Synthesization')} />
                                    <label htmlFor="ingredient6" className="ml-2">Synthesization</label>
                                </div>
                            </div>
                        }
                        {/* <Button label="New Topic" outlined icon="pi pi-plus" className='btn-voice-list outline-icon-btn' onClick={() => fileInputRef.current.click()} />
                        <input id='uploadDoc' ref={fileInputRef} type="file" placeholder='Upload document' onChange={handleBrowseFiles} className="d-none" accept='application/pdf' name="fileUpload" /> */}
                        <Button label="New Topic" ref={fileInputRef} outlined icon="pi pi-plus" className={`btn-voice-list outline-icon-btn`} onClick={() => handleNewChatClick("documate")} />
                    </div>
                    {Object.keys(docuMatePDF).length > 0 &&
                        <div className='home-search mt-3'>
                            <InputText className='radius-input' style={{ cursor: "auto" }} value={docuMateText} onKeyDown={(e) => handleEnterPressedDocuMate(e)} onChange={handleInputChangeDocuMate} ref={inputRefDocuMate} placeholder='Ask me anything' onFocus={() => dispatch(handleDocuMateRadio("Q&A"))} />
                            <i className='last-icon' style={{ opacity: docuMateText === "" || docuMateText.trim() === "" ? "0.5" : "", pointerEvents: docuMateText === "" || docuMateText.trim() === "" ? "none" : "visible" }} onClick={handleSendQueryButtonDocuMate} id='send-button'><img src={searchSend} alt='send-btn' /></i>
                        </div>
                    }
                </div>
            }
            {temp[0] === 'voice' &&
                <div className='user-input-area user-input-voice'>
                    <div className='user-input-voice-left'>
                        <div className='home-search' style={{ pointerEvents: localStorage.getItem("clientName") !== 'Veedalifescience' ? 'visible' : 'none' }} onClick={handleVoiceToggle}>
                            <InputText className='radius-input c-pointer' placeholder='Upload voice file' readOnly />
                            <i className='last-icon'><img src={uploadIcon} alt='upload-icon' /></i>
                        </div>
                        <input id='uploadDoc' ref={voiceInputRef} type="file" placeholder='Upload document' className="d-none" accept=".mp3,.wav,.ogg,.aac" name="fileUpload" onChange={handleVoiceChange} />
                        <p className='helper-text'><i><img src={helperDoc} alt='qmate-icon' /></i><b>File formats:</b> .mp3, .wav, .aac, .ogg with a maximum file size limit of <b>5 MB</b>.</p>
                    </div>
                    <Button label="List View" outlined icon="pi pi-list" className={`btn-voice-list outline-icon-btn ${temp[0] === "voice" && temp[1] === undefined ? "active" : ""}`} onClick={() => navigate("/voice")} />
                </div >
            }
            {
                temp[0] === 'lens' && temp[1] !== 'image-comparison' &&
                <div className='user-input-area user-input-voice'>
                    <div className='user-input-voice-left'>
                        <div className='home-search' onClick={handleLensToggle}>
                            <InputText className='radius-input c-pointer' placeholder='Upload Image' readOnly />
                            <i className='last-icon'><img src={uploadIcon} alt='upload-icon' /></i>
                        </div>
                        <input id='uploadDoc' ref={lensInputRef} type="file" placeholder='Upload document' className="d-none" accept=".jpg,.png,.webp,.jpeg" name="fileUpload" onChange={handleLensChange} />
                        <p className='helper-text'><i><img src={uploadImage} alt='qmate-icon' /></i><b>File formats:</b> .jpg, .png, .webp with a maximum file size limit of <b>10 MB</b>.</p>
                    </div>
                </div>
            }
            {
                temp[1] === 'image-comparison' &&
                <div className='user-input-area input-area'>
                    <div className='input-left'>
                        <div className='search-area'>
                            <div className="resize-section">
                                {/* <label htmlFor="">Grid Detection</label> */}
                                <div className="resize-option">
                                    <RadioButton className='c-pointer' inputId="val1" name="resize1" value="objectDetection" checked={imageCompRadio === "objectDetection"} onChange={(e) => handleRadioChange(e)} />
                                    <label htmlFor="val1">Object Detection</label>
                                </div>
                                <div className="resize-option">
                                    <RadioButton className='c-pointer' inputId="val2" name="resize2" value="grid" checked={imageCompRadio === "grid"} onChange={(e) => handleRadioChange(e)} />
                                    <label htmlFor="val2">Grid</label>
                                </div>
                            </div>
                        </div>
                        {/* <button className="new-image-btn" onClick={() => dispatch(setNewImage("New Image"))}>+ New Image</button> */}
                        <Button label="New Image" outlined icon="pi pi-plus" className='outline-icon-btn' onClick={() => dispatch(setNewImage("New Image"))} />
                    </div>
                </div>
            }
            {
                solutionsArray.includes(temp[0]) &&
                <div className='user-input-area flex-row-reverse'>
                    {/* <div className='home-search'>
                        <InputText style={{ cursor: "auto" }} onKeyDown={(e) => handleEnterPressedEmail(e)} onChange={handleInputChangeEmail} value={emailGen} className='radius-input input-box' placeholder='Ask me anything' />
                        <i className='last-icon' style={{ opacity: emailGen === "" ? "0.5" : "", pointerEvents: emailGen === "" ? "none" : "visible" }} onClick={handleSendQueryButtonEmail} id='send-button'><img src={searchSend} alt='send-btn' /></i>
                    </div> */}
                    <Button label="New Topic" outlined icon="pi pi-plus" className='btn-voice-list float-end outline-icon-btn' onClick={() => handleNewChatClick("generateEmail")} />
                </div>
            }
            <div className='profile-img-wrap'>
                <div className='menu-heading'>
                    {imageSrc() !== "" &&
                        <i><img src={imageSrc()} alt='profile-icon' /></i>
                    }
                    {/* {(imageSrc() !== "" || currentActive === "bot") &&
                        <i><img src={currentActive === "bot" && imageSrc() === "" ? homeBot : imageSrc()} alt='profile-icon' /></i>
                    } */}
                    <strong>{componentName()}</strong>
                    {/* <strong>{currentActive === "bot" && componentName() === "" ? "Bot!" : componentName()}</strong> */}
                </div>
                {/* {temp[0] !== 'home' && */}
                {localStorage.getItem('clientName') !== 'Amspec_clone' && localStorage.getItem('username') !== 'sales@rysun.com' &&
                    <div className='header-dots' onClick={(e) => { e.stopPropagation(); oh?.current?.toggle(e); overlayLens?.current?.hide(); }}>
                        <i><img src={helperDots} alt='header-dots' /></i>
                    </div>
                }
                {/* } */}
                <OverlayPanel ref={oh} className='header-overlay'>
                    <div className='header-overlay-wrap'>
                        <div className='header-overlay-body'>
                            <div className='seprate-heading'>Platform!</div>
                            <ul className='header-overlay-list'>
                                {q_aManagementObject?.permissions &&
                                    <li onClick={(e) => handleMenu("qmate", "")}>
                                        <a className='home-content-active'>
                                            <img src={homeQmate} alt='qmate-icon' />
                                            <span>QMate!</span>
                                        </a>
                                    </li>
                                }
                                {uploadDocManagementObject?.permissions &&
                                    <li onClick={(e) => handleMenu("documate", "")}>
                                        <a>
                                            <img src={homeDocumate} alt='documate-icon' />
                                            <span>DocuMate!</span>
                                        </a>
                                    </li>
                                }
                                {voiceManagementObject?.permissions &&
                                    <li onClick={(e) => handleMenu("voice", "")}>
                                        <a>
                                            <img src={homeVoice} alt='voice-icon' />
                                            <span>Voice!</span>
                                        </a>
                                    </li>
                                }
                                {/* {botManagementObject?.permissions &&
                                    <li onClick={(e) => handleMenu("bot", "")}>
                                        <a>
                                            <img src={homeBot} alt='bot-icon' />
                                            <span>Bot!</span>
                                        </a>
                                    </li>
                                } */}
                                {localStorage.getItem("clientName") !== 'Veedalifescience' &&
                                    <li>
                                        <Link to="/user-dashboard" onClick={() => oh.current.hide()} className='home-content-active'>
                                            <img src={Dashboard} alt='qmate-icon' />
                                            <span>User Dashboard</span>
                                        </Link>
                                    </li>
                                }
                                {adminShow &&
                                    <li onClick={(e) => { handleMenu("admin", ""); dispatch(handleNotFound(false)); }}>
                                        <a>
                                            <img src={Admin} alt='documate-icon' />
                                            <span>Admin</span>
                                        </a>
                                    </li>
                                }
                            </ul>
                            {lensObject && <>
                                <div className='seprate-heading'>Lens!</div>
                                <ul className='header-overlay-list'>
                                    {similarImagesObject?.permissions &&
                                        <li onClick={(e) => handleMenu("lens", "Similar Images")}>
                                            {/* <li onClick={(e) => handleMenu("lens", "")}> */}
                                            {/* <a className='home-content-active'>
                                        <img src={homeLens} alt='qmate-icon' />
                                        <span>Lens!</span>
                                    </a> */}
                                            <a className='home-content-active'>
                                                <img src={lensImage} alt='qmate-icon' />
                                                <span>Similar Image</span>
                                            </a>
                                        </li>
                                    }
                                    {smartBackgroundObject?.permissions &&
                                        <li onClick={(e) => handleMenu("lens", "Smart Background")}>
                                            <a>
                                                <img src={lensSmartBack} alt='documate-icon' />
                                                <span>Smart Background</span>
                                            </a>
                                        </li>
                                    }
                                    {generateInstanceObject?.permissions &&
                                        <li onClick={(e) => handleMenu("lens", "Generate Instance")}>
                                            <a>
                                                <img src={lensAi} alt='voice-icon' />
                                                <span>Generate Instance</span>
                                            </a>
                                        </li>
                                    }
                                    {imageExtenderObject?.permissions &&
                                        <li onClick={(e) => handleMenu("lens", "Image Extender")}>
                                            <a>
                                                <img src={imageExpansion} alt='voice-icon' />
                                                <span>Image Extender</span>
                                            </a>
                                        </li>
                                    }
                                    {imageComparisionObject?.permissions &&
                                        <li onClick={(e) => handleCompareImage("Image Comparison")}>
                                            <a>
                                                <img src={imageCompare} alt='voice-icon' />
                                                <span>Image Comparison</span>
                                            </a>
                                        </li>
                                    }
                                </ul>
                            </>}
                            <div className='seprate-heading'>Products!</div>
                            <ul className='header-overlay-list'>
                                {
                                    botManagementObject?.permissions && localStorage.getItem("clientName") !== 'Veedalifescience' &&
                                    <li onClick={handleShopMate}>
                                        <a>
                                            <img src={shopMateIcon} alt='shopmate-icon' />
                                            <span className='temp_span'>ShopMate</span>
                                        </a>
                                    </li>
                                }
                                {
                                    marketObject && <>
                                        <li onClick={handleSolution}>
                                            <a>
                                                <img src={revMateIcon} alt='revmate-icon' />
                                                <span>RevMate</span>
                                            </a>
                                        </li>
                                    </>
                                }
                                {
                                    localStorage.getItem("clientName") !== 'Veedalifescience' &&
                                    <li onClick={handleButterPie}>
                                        <a>
                                            <img src={techMateIcon} alt='techumate-icon' />
                                            <span className='temp_span'>CreatorMate</span>
                                        </a>
                                    </li>
                                }
                            </ul >
                            <div className='seprate-heading'>POC!</div>
                            <ul className='header-overlay-list header-overlay-list--poc'>
                                <li>
                                    <a href="https://edumatewebsite.rysun.in/login" target="_blank" rel="noopener noreferrer" onClick={() => oh.current.hide()}>
                                        <img src={edumateIcon} alt='qmate-icon' />
                                        <span>Edugen AI</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://insuranceaife.rysun.in/" target="_blank" rel="noopener noreferrer" onClick={() => oh.current.hide()}>
                                        <img src={insuranceIcon} alt='documate-icon' />
                                        <span>Insurance AI</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://veedabrwebappqa.rysun.in/login" target="_blank" rel="noopener noreferrer" onClick={() => oh.current.hide()}>
                                        <img src={veedaIcon} alt='voice-icon' />
                                        <span>Veeda</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://aira.rysun.in" target="_blank" rel="noopener noreferrer" onClick={() => oh.current.hide()}>
                                        <img src={airaAiIcon} alt='aira-icon' />
                                        <span>Aira AI</span>
                                    </a>
                                </li>
                            </ul>
                        </div >
                        {/* <div className='header-overlay-body header-overlay-bottom'>
                            <ul className='header-overlay-list'>
                                <li>
                                    <Link to="/forecast" onClick={() => oh.current.hide()} className='home-content-active'>
                                        <img src={Forecast} alt='qmate-icon' />
                                        <span>Inventory Forecast</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/user-dashboard" onClick={() => oh.current.hide()} className='home-content-active'>
                                        <img src={Dashboard} alt='qmate-icon' />
                                        <span>User Dashboard</span>
                                    </Link>
                                </li>
                                <li onClick={(e) => handleMenu("admin", "")}>
                                    <a>
                                        <img src={Admin} alt='documate-icon' />
                                        <span>Admin</span>
                                    </a>
                                </li>
                            </ul>
                        </div> */}
                    </div >
                </OverlayPanel >
                <div className='profile-img' onClick={(e) => op.current.toggle(e)}>
                    {firstLetter}
                </div>
                <OverlayPanel ref={op} className='profile-overlay'>
                    <div className='profile-overlay-wrap'>
                        <div className='profile-overlay-header'>
                            <div className='profile-img-big'>{firstLetter}</div>
                            <div className='profile-header-right'>
                                <p>Welcome to RysunAI!</p>
                                <strong title={`${fName} ${lName}`}>{`${fName} ${lName}`}</strong>
                                <p title={`${userName}`}>{userName}</p>
                            </div>
                        </div>
                        <div className='profile-overlay-body'>
                            <ul>
                                {/* {featureFlag.debug &&
                                    (<li><span>Debug Mode</span> <InputSwitch checked={is_switch_active} onChange={handleSwitchChange} /></li>)} */}
                                {(ShowChangePassword === true || ShowChangePassword === undefined) &&
                                    <li onClick={() => setChangeVisible(true)} style={{ cursor: "pointer" }}><a>Change password</a></li>
                                    // onClick={handleChangePassword}
                                }
                                <li onClick={() => {
                                    setVisible(true);
                                    const synth = window.speechSynthesis;
                                    if (synth.speaking) {
                                        synth.cancel();
                                    }
                                    dispatch(setStopId(''));
                                    op.current.hide();
                                }} style={{ cursor: "pointer" }}><a>Sign Out</a></li>
                            </ul>
                        </div>
                    </div>
                </OverlayPanel>
                <ConfirmDialog header="Confirmation" visible={visible} onHide={() => setVisible(false)} message="Are you sure you want to sign out?"
                    icon="pi pi-exclamation-triangle" accept={handleSignout} reject={reject} />
                <Sidebar position="right" header={customHeader} visible={changeVisible} onHide={() => handleCloseChangePassword()} className='form-sidebar'>
                    <form >
                        <div className="form-sidebar-body">
                            <div className='form-row'>
                                <div className='form-col'>
                                    <label className="form-label">Current Password<i>*</i></label>
                                    <div className='position-relative'>
                                        <InputText type={showOldPassword ? "text" : "password"} className="p-inputtext p-component" id="currentPassword" name="oldPassword" aria-describedby="emailHelp" placeholder="Enter Current Password"
                                            value={formValue.oldPassword}
                                            onChange={(e) => {
                                                delete errors.oldPassword;
                                                handleChange(e);
                                            }} />
                                        <span className={`password-toggle position-absolute top-50 end-0 w-auto translate-middle`} onClick={() => setShowOldPassword(!showOldPassword)}>
                                            {showOldPassword ? <img id='eyeicon' src={eyeIcon} alt="eye-icon" /> :
                                                <img id='close-eye-icon' src={CloseEyeIcon} alt="close-eye-icon" />
                                            }
                                        </span>
                                    </div>
                                    {errors.oldPassword && <span id="emailHelp" className="mt-2 text-danger">{errors.oldPassword}</span>}
                                </div>
                            </div>
                            <div className='form-row'>
                                <div className='form-col'>
                                    <label className="form-label">New Password<i>*</i></label>
                                    <div className='position-relative'>
                                        <InputText type={showPassword ? "text" : "password"}
                                            className="p-inputtext p-component"
                                            id="exampleInputPassword2"
                                            name="newPassword"
                                            placeholder="Enter New Password"
                                            required
                                            value={formValue.newPassword}
                                            onChange={(e) => {
                                                delete errors.newPassword;
                                                handleChange(e);
                                            }} />
                                        <span className={`password-toggle position-absolute top-50 end-0 w-auto translate-middle`} onClick={() => setShowPassword(!showPassword)}>
                                            {showPassword ? <img id='eyeicon' src={eyeIcon} alt="eye-icon" /> :
                                                <img id='close-eye-icon' src={CloseEyeIcon} alt="close-eye-icon" />
                                            }
                                        </span>
                                    </div>
                                    {errors.newPassword && <span className="mt-2 text-danger">{errors.newPassword}</span>}
                                </div>
                            </div>
                            <div className='form-row'>
                                <div className='form-col'>
                                    <label className="form-label">Confirm Password<i>*</i></label>
                                    <div className='position-relative'>
                                        <InputText type={showCnfPassword ? "text" : "password"}
                                            className="p-inputtext p-component"
                                            id="exampleInputPassword1"
                                            placeholder="Enter Confirm Password"
                                            name='confirmPassword'
                                            required
                                            value={formValue.confirmPassword}
                                            onChange={(e) => {
                                                delete errors.confirmPassword;
                                                handleChange(e);
                                            }} />
                                        <span className={`password-toggle position-absolute top-50 end-0 w-auto translate-middle`} onClick={() => setShowCnfPassword(!showCnfPassword)}>
                                            {showCnfPassword ? <img id='eyeicon' src={eyeIcon} alt="eye-icon" /> :
                                                <img id='close-eye-icon' src={CloseEyeIcon} alt="close-eye-icon" />
                                            }
                                        </span>
                                    </div>
                                    {errors.confirmPassword && <span className="mt-2 text-danger">{errors.confirmPassword}</span>}
                                </div>
                            </div>
                        </div>
                        <div className='form-sidebar-footer'>
                            <Button className='grey-outline-btn btn-lg' type='button' label='Cancel' onClick={() => handleCloseChangePassword()}></Button>
                            <Button className='outline-active-btn btn-lg' type="submit" onClick={handleUpdatePassword} label='Save'></Button>
                        </div>
                    </form>
                </Sidebar>
            </div >
        </div >
    )
}

export default HeaderOne